
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';


import { Injectable } from '@angular/core';
import { LcpHelper } from '../_helpers/lcp-helper';
// import { Router } from '@angular/router';


@Injectable()
export class TypableService {

  constructor(
    private lcpHelper: LcpHelper
  ) {}


  initIntersectionObserver(el: any, params={}) {
    // console.log('CHECK: IIO el', el)
    const observer = new IntersectionObserver( 
      ([e]) => {
        // if (this.mobileTypedServiceIndices.includes(i)) return 
        if (el.classList.contains('was-typed')) return // console.log('CHECK is-typed', el)
        if (e.intersectionRatio < 0.05) return
        // el.classList.add('was-typed')
        // console.log('TODO: type mobile', i, e.target)
        const typableTextElement = this.typableTextElementWithinContainer(e.target)
        if (!typableTextElement) return console.log('ERR: !typableTextElement', e.target)
        // console.log('TODO: type mobile', i, this.fields)
        this.typeTextNow(typableTextElement, params).then(res => {
          el.classList.add('was-typed')
        })
      },

      // ([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1), 
      { rootMargin: '300px 0px -200px 0px',
        threshold: this.lcpHelper.percentageSequence(500) }
    );

    // console.log('scroll-inter', el)
    observer.observe(el)
    return observer
  }

  typableTextElementWithinContainer(el: Element) {
    return el.querySelector('.typable-text')
    // console.log('CHECK typableTextElementWithinContainer', el)
    // return el.querySelector('.typable-container')
  }


  async typeText(params={}): Promise<boolean> {
    const evt = params['event']
    const container = evt && evt.target && evt.target.closest('.typable-container')
    if (!container) console.log('ERR: typeText !container', evt.target)

    // const typableTextElement = this.typableTextElementWithinContainer(container)
    const typableTextElement = params['typableTextElement']
    // const typableTextElement = this.serviceDescriptionElementDesktopFromIndex(params['index'])
    if (!typableTextElement) { console.log('ERR: !typableTextElement', params); return false }

    // this.lcpHelper.stopTypingElement(typableTextElement)
    // setTimeout(this.typeTextNow.bind(this, typableTextElement, params), 100)
    return this.typeTextNow(typableTextElement, params)
  }

  async typeTextNow(el: Element, params={}): Promise<boolean> {
    // console.log('CHECK: typeTextNow', el, params)
    this.lcpHelper.stopAllTyping = false 
    let block = params['block']
    let text = params['text']
    let link = params['link'] // this.lcpHelper.linkFromBlock(params['block'])

    if (block) {
      if (!text) text = documentToPlainTextString(block.fields['body'])
      if (!link) link = this.lcpHelper.linkFromBlock(params['block'])
    }

    // const container = elements && elements[0]
    // const typableTextElement = this.serviceDescriptionElementDesktopFromIndex(params['index'])
    if (el.classList.contains('was-typed')) return true // console.log('IS-TYPED')
    if (el.classList.contains('is-typing')) return false // console.log('IS-TYPED')
    el.classList.add('is-typing')
    // el.closest('.typable-text-container').classList.add('is-typed')

    const cursorContainer = el.parentElement?.querySelector('.typable-cursor-container') 
    if (!cursorContainer) { console.log('ERR: !cursorContainer', el); return Promise.resolve(false); }

    cursorContainer.classList.remove('opacity-0')

    el.innerHTML = ''

    // const plainText = documentToPlainTextString(text)
    const typeParams = Object.assign({}, { shouldType: true, delay: 10, minDelay: 5 }, params)

    // console.log('CHECK: typeTextNow', params, 'TEXT:', text, el)

    // this.lcpHelper.isTypingElements.push(el)
    // console.log('CHECK: text?', text, el)
    if (text) await this.lcpHelper.typeSentence(text, el, typeParams)

    // if (!this.lcpHelper.isTypingElements.includes(el)) return // console.log('ERR: !isTypingElements', el)

    if (link) {
      if (text) el.insertAdjacentHTML('beforeend', '  ')
      let a = document.createElement('a');
      // console.log('CHECK LINK', link)
      a.href = link.address // Instead of calling setAttribute 
      // a.innerHTML = link.text
      el.appendChild(a)
      const linkTypeParams =  Object.assign({}, { shouldType: true, delay: 50, minDelay: 10 }, params)
      this.lcpHelper.typeSentence(link.text, a, linkTypeParams)
      // el.insertAdjacentHTML('beforeend', ' ')
      // console.log('TYPED LINK', el)
      // el.insertAdjacentHTML('beforeend', `<a href=${link.address}>${link.text}</a>`)
      this.listenToLinkHover(el)
    }
    
    // typable-cursor-container
    if (params['removeCursorAfterTyping']) cursorContainer?.classList.add('opacity-0')

    // el.classList.add('is-typed')
    el.classList.add('was-typed')
    el.classList.remove('is-typing')
    return Promise.resolve(true)
  }

  listenToLinkHover(el: Element) {
    const link = el.querySelector('a')

    link.addEventListener('mouseenter', () => {
      // console.log('handleLinkHover', link)
      const container = this.getLinkContainer(link)
      const cursor = this.getContainerCursor(container)
      if (!cursor) return 
      cursor.classList.add('opacity-0')
      // Code to execute when the mouse enters the link area
      // link.style.backgroundColor = 'lightblue'; // Example: change background color
    })

    link.addEventListener('mouseleave', () => {
      // console.log('handleLinkBlur', link)
      const container = this.getLinkContainer(link)
      const cursor = this.getContainerCursor(container)
      if (!cursor) return 
      cursor.classList.remove('opacity-0')
      // Code to execute when the mouse leaves the link area
      // link.style.backgroundColor = 'initial'; // Example: revert background color
    })
  }

  getLinkContainer(link: Element): Element {
    const container = link.closest('.typable-text-outer')
    if (!container) { console.log('ERR: !container', link); return null }
    return container
  }

  getContainerCursor(container: Element): Element {
    const cursorElement = container.querySelector('.typable-cursor')
    if (!cursorElement) { console.log('ERR: !cursor', container); return null }
    return cursorElement
  }

  resetRepeatables(repeatables: any[]) {
    repeatables.forEach(el=> {
      if (el.classList.contains('is-typing')) return
      el.innerHTML = null
      el.classList.remove('was-typed')
    })
  }

}
